import ReceiptInvoice from './ReceiptInvoice';

export default ReceiptInvoice;